module.exports = __webpack_public_path__ + "static/icon_googleplay-2fa11670aa0a9c14be16d2ed3ac2cda9.svg";